import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ConfirmModalModule } from 'Angular/features/components/modals/confirm-modal/confirm-modal.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';

import { OpenItemListComponent } from 'Angular/features/components/saved-items/open-item-modal/components/open-item-list/open-item-list.component';
import { OpenItemModalComponent } from 'Angular/features/components/saved-items/open-item-modal/components/open-item-modal/open-item-modal.component';
import { OpenItemPreviewModalComponent } from 'Angular/features/components/saved-items/open-item-modal/components/open-item-preview-modal/open-item-preview-modal.component';
import { OpenItemTabsComponent } from 'Angular/features/components/saved-items/open-item-modal/components/open-item-tabs/open-item-tabs.component';

@NgModule({
    declarations: [OpenItemModalComponent, OpenItemListComponent, OpenItemPreviewModalComponent, OpenItemTabsComponent],
    exports: [OpenItemModalComponent, OpenItemTabsComponent, OpenItemPreviewModalComponent],
    imports: [
        ConfirmModalModule,
        CommonModule,
        DisabledModule,
        FeatureNeededModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        LoadingSymbolModule,
        ModalBaseModule,
        TooltipModule,
    ],
})
export class OpenItemModalModule {}
